let debounce = require('lodash/debounce');

export default function caseSearchComponentClassInit(coreHandlerInstance) {
  const coreHandler = coreHandlerInstance;

  class caseSearchComponentClass {
    static instanceList = [];
  
    static init() {
      let caseSearchInstance = coreHandler.searchClass.instanceList.filter(instance => instance.mode === "case");
      // console.log( "caseSearchInstance" , caseSearchInstance );
      caseSearchComponentClass.instanceList = caseSearchInstance.map( instance => new caseSearchComponentClass(instance));
    }

    static getRegexItem(string){
      let matchInstanceList = caseSearchComponentClass.instanceList.filter(instance => instance.regexCheck(string));   
      // console.log("matchInstanceList" , matchInstanceList );
      matchInstanceList = caseSearchComponentClass.removeDuplicatesByMultipleParent(matchInstanceList);
        
      return matchInstanceList;
    }

    static removeDuplicatesByMultipleParent(caseSearchComponentInstance) {
      let excludedParents  = caseSearchComponentInstance.map(instance => instance.multipleSelector).filter((selector, index, self) => selector !== null && self.indexOf(selector) === index);
      let filteredArray = caseSearchComponentInstance.filter(instance => instance.multipleParent == null || !excludedParents.includes(instance.multipleParent) );

      return filteredArray;
    }


    static mergeMatchInstanceList = (caseSearchInstanceArray) => {
      const mergeMatchInstanceList = [];
    
      if (caseSearchInstanceArray.length < 1) return mergeMatchInstanceList;

      caseSearchInstanceArray.forEach( argCaseInstance => {

        argCaseInstance.forEach( caseSearchSingleInstance => {
          const haveSameInstance = mergeMatchInstanceList.find( mergeSingleInstance => mergeSingleInstance.itemId === caseSearchSingleInstance.itemId  );
          if( !haveSameInstance ){
            mergeMatchInstanceList.push( caseSearchSingleInstance );
          }

        });

      });
      const removeDuplicatesByMultipleParentMergeInstanceList = caseSearchComponentClass.removeDuplicatesByMultipleParent(mergeMatchInstanceList);
    

      // console.log("removeDuplicatesByMultipleParentMergeInstanceList", removeDuplicatesByMultipleParentMergeInstanceList);

      return removeDuplicatesByMultipleParentMergeInstanceList;
    }
    
    
    


    constructor(caseSearchInstance){
      this.instanceType = "caseSearchComponentClass";
      this.itemId = caseSearchInstance.itemId !== null ? caseSearchInstance.itemId : null;
      this.label = caseSearchInstance.labelText !== null ? caseSearchInstance.labelText : null;
      this.propertyId = caseSearchInstance.propertyId !== null ? caseSearchInstance.propertyId  : null;
      this.multipleSelector = caseSearchInstance.multipleSelector !== null ? caseSearchInstance.multipleSelector : null;
      this.multipleParent = caseSearchInstance.multipleParent !== null ? caseSearchInstance.multipleParent : null;
      this.suggestList = caseSearchInstance.suggestList !== null ? caseSearchInstance.suggestList : null;
      this.mergeList = this.mergeLabelSuggestList();

    }

    mergeLabelSuggestList = () => {
      if (this.label === null && this.suggestList === null) {
        return null;
      }
    
      let result = this.label || '';
    
      if (this.suggestList !== null) {
        // カンマをパイプに変換して結合
        const convertedSuggestList = this.suggestList.replace(/,/g, '|');
        result += "|" + convertedSuggestList;
      }
    
      return result;
    }

    regexCheck = (string) => {
      const regex = new RegExp(string.toLowerCase());
      return this.mergeList.split('|').some(item => regex.test(item.toLowerCase()));
    }
  }



  caseSearchComponentClass.init();

  // console.log("caseSearchComponentClass.instanceList", caseSearchComponentClass.instanceList );
  return caseSearchComponentClass;
}